<mobi-content-section
  [animation]="false"
  [id]="
    (anchorId()
      ? anchorId()
      : ('insurance_in_short_paramenter_name'
        | texts: { context: 'frontend', default: 'versicherung_in_kuerze' })
    ) | anchorFormatter
  "
  [content]="inShortContent"
>
  <ng-template #inShortContent>
    <mobi-section-title
      class="view-enter-animation"
      [centered]="false"
      [title]="inShortTitle()"
      [description]="inShortText()"
      [additionalTitle]="inShortSubtitle()"
    ></mobi-section-title>

    <!-- ADVANTAGES PRODUCT SECTION -->
    @if (breakpoint.smMax()) {
      <mobi-ui-carousel-major
        [maxColumns]="3"
        class="view-enter-animation force-indicator-and-buttons is-controls-bottom is-buttons-primary"
      >
        <!-- Duplicate hydration rendering fix: https://github.com/angular/angular/issues/50543#issuecomment-1573339782 -->
        <ng-content /><ng-template [ngTemplateOutlet]="advantagesContent"></ng-template>
      </mobi-ui-carousel-major>
    } @else {
      <div
        [class]="
          'mobi-ui-grid is-gap-md is-align-stretch view-enter-animation' +
          (advantages() && advantages()!.length <= 2 ? ' justify-center' : '')
        "
      >
        <!-- Duplicate hydration rendering fix: https://github.com/angular/angular/issues/50543#issuecomment-1573339782 -->
        <ng-content /><ng-template
          [ngTemplateOutlet]="advantagesContent"
          [ngTemplateOutletContext]="{
            classes: 'mobi-ui-col-1/3 ',
          }"
        ></ng-template>
      </div>
    }
    <ng-template #advantagesContent let-classes="classes">
      @for (advantage of advantages(); let i = $index; track advantage.uuid) {
        <div [class]="classes">
          <mobi-card
            class="flex justify-center h-full"
            [attr.data-delay]="i * 100"
            [cardTitle]="advantage.title"
            [cardText]="advantage.description"
            cardStyle="swipe"
            [cardNumber]="i + 1"
            [cardTotal]="advantages() && advantages()!.length ? advantages.length : 0"
            cardTitleSize="h3"
          ></mobi-card>
        </div>
      }
    </ng-template>
  </ng-template>
</mobi-content-section>

@if (comboProduct()) {
  <mobi-product-relation
    class="block view-enter-animation"
    [products]="[comboProduct()!]"
    [productTitle]="productTitle()!"
    [productsTitle]="
      'product_is_part_of' | texts: { context: 'frontend', default: 'Ist teil der' }
    "
    [sectionTitle]="comboProductSectionTitle()"
  ></mobi-product-relation>
}

<!-- COMBO PRODUCT SECTION -->
@if (products() && !hideRelation()) {
  <mobi-product-relation
    class="block view-enter-animation"
    [products]="products()!"
    [productTitle]="productTitle()"
    [productsTitle]="productsTitle()"
    [sectionTitle]="comboProductSectionTitle()"
  ></mobi-product-relation>
}

@if (video()) {
  <mobi-content-section [content]="videoContent">
    <ng-template #videoContent>
      <mobi-media class="block" [entity]="video()" />
      @if (video()?.description) {
        <mobi-text
          class="pt-[10px] mobi-ui-font-italic block"
          [data]="video()!.description!"
        />
      }
    </ng-template>
  </mobi-content-section>
}
<!-- award section -->
@if (productAward()) {
  <mobi-content-section [content]="awardContent" width="lg">
    <ng-template #awardContent>
      <mobi-product-award [award]="productAward()!" class="block view-enter-animation" />
    </ng-template>
  </mobi-content-section>
}
